// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import { getOperatingSystem } from '@/lib/utils';

export enum KeyboardShortcutAction {
  TOGGLE_SIDE_PANEL = 'toggle_side_panel',
  TOGGLE_THEME = 'toggle_theme',
  TOGGLE_MIC = 'toggle_mic',
  TOGGLE_CAMERA = 'toggle_camera',
}

export interface KeyboardShortcut {
  action: KeyboardShortcutAction;
  keyCombinationLabelMac: string;
  keyCombinationLabelWin: string;
  keyCombinationMac: string;
  keyCombinationWin: string;
}

export const keyboardShortcuts: Record<KeyboardShortcutAction, KeyboardShortcut> = {
  // [KeyboardShortcutAction.TOGGLE_SIDE_PANEL]: {
  //   action: KeyboardShortcutAction.TOGGLE_SIDE_PANEL,
  //   keyCombinationLabelMac: '⌘B',
  //   keyCombinationLabelWin: 'Ctrl+B',
  //   keyCombinationMac: 'meta+b',
  //   keyCombinationWin: 'ctrl+b',
  // },
  [KeyboardShortcutAction.TOGGLE_THEME]: {
    action: KeyboardShortcutAction.TOGGLE_THEME,
    keyCombinationLabelMac: '⌘Q',
    keyCombinationLabelWin: 'Ctrl+Q',
    keyCombinationMac: 'meta+q',
    keyCombinationWin: 'ctrl+q',
  },
  [KeyboardShortcutAction.TOGGLE_MIC]: {
    action: KeyboardShortcutAction.TOGGLE_MIC,
    keyCombinationLabelMac: '⌘⇧M',
    keyCombinationLabelWin: 'Ctrl+Shift+M',
    keyCombinationMac: 'meta+shift+m',
    keyCombinationWin: 'ctrl+shift+m',
  },
  [KeyboardShortcutAction.TOGGLE_CAMERA]: {
    action: KeyboardShortcutAction.TOGGLE_CAMERA,
    keyCombinationLabelMac: '⌘⇧C',
    keyCombinationLabelWin: 'Ctrl+Shift+C',
    keyCombinationMac: 'meta+shift+c',
    keyCombinationWin: 'ctrl+shift+c',
  },
  // [KeyboardShortcutAction.TOGGLE_SOUND]: {
  //   action: KeyboardShortcutAction.TOGGLE_SOUND,
  //   keyCombinationLabelMac: '⌘⇧O',
  //   keyCombinationLabelWin: 'Ctrl+Shift+O',
  //   keyCombinationMac: 'meta+shift+o',
  //   keyCombinationWin: 'ctrl+shift+o',
  // },
  // ONLY VISUAL
  // [KeyboardShortcutAction.PUSH_TO_TALK]: {
  //   action: KeyboardShortcutAction.PUSH_TO_TALK,
  //   keyCombinationLabelMac: 'Space',
  //   keyCombinationLabelWin: 'Caps Lock',
  //   keyCombinationMac: 'Space',
  //   keyCombinationWin: 'capslock',
  // },
};

export interface KeyboardShortcutForOS {
  action: KeyboardShortcutAction;
  keyCombinationLabel: string;
  keyCombination: string;
}

const operatingSystem = getOperatingSystem();

export const keyboardShortcutsForOS: Record<
  KeyboardShortcutAction,
  KeyboardShortcutForOS
> = Object.keys(keyboardShortcuts).reduce(
  (acc, action) => {
    const keyboardShortcut =
      keyboardShortcuts[action as KeyboardShortcutAction];
    const keyCombinationLabel =
      operatingSystem === 'mac'
        ? keyboardShortcut.keyCombinationLabelMac
        : keyboardShortcut.keyCombinationLabelWin;
    const keyCombination = keyboardShortcut.keyCombinationWin;
      operatingSystem === 'mac'
        ? keyboardShortcut.keyCombinationMac
        : keyboardShortcut.keyCombinationWin;

    return {
      ...acc,
      [action]: {
        action: keyboardShortcut.action,
        keyCombinationLabel,
        keyCombination,
      },
    };
  },
  {} as Record<KeyboardShortcutAction, KeyboardShortcutForOS>
);
